import * as React from 'react';
import { useLink } from '@grandvisionhq/frk-routing';
import { ErrorPage } from '@grandvisionhq/layout';
import { useIntl } from '@grandvisionhq/state';
import Support from '../../Profile/components/Support/Support.js';

const PageNotFound = ()=>{
    const { getLabel  } = useIntl();
    const link = useLink({
        route: 'me.profile'
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "page-not-found"
    }, /*#__PURE__*/ React.createElement(ErrorPage, {
        header: getLabel('common.pageNotFound.header'),
        subheader: getLabel('common.pageNotFound.subheader'),
        buttonText: getLabel('account.pageNotFound.buttonText'),
        buttonHref: link === null || link === void 0 ? void 0 : link.href
    })), /*#__PURE__*/ React.createElement(Support, null));
};
var PageNotFound$1 = PageNotFound;

export { PageNotFound$1 as default };
//# sourceMappingURL=PageNotFound.js.map
